'use strict';

module.exports = list;

/* Which method to use based on `list.ordered`. */
var ORDERED_MAP = {
  true: 'visitOrderedItems',
  false: 'visitUnorderedItems'
};

function list(node) {
  return this[ORDERED_MAP[node.ordered]](node);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/list.js
// module id = 806
// module chunks = 168707334958949